// Acceso a la geolocalización del dispositivo. Ver CLAUDE.md §7.
import { useCallback, useState } from 'react'

export interface Coords {
  lat: number
  lng: number
  accuracy: number
}

export function useGeolocation() {
  const [coords, setCoords] = useState<Coords | null>(null)
  const [error, setError] = useState<string | null>(null)

  const getCurrent = useCallback((): Promise<Coords> => {
    return new Promise((resolve, reject) => {
      if (!('geolocation' in navigator)) {
        const msg = 'Este dispositivo no soporta geolocalización.'
        setError(msg)
        return reject(new Error(msg))
      }
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const c = { lat: pos.coords.latitude, lng: pos.coords.longitude, accuracy: pos.coords.accuracy }
          setCoords(c)
          resolve(c)
        },
        (err) => {
          setError(err.message)
          reject(err)
        },
        { enableHighAccuracy: true, timeout: 10000 },
      )
    })
  }, [])

  return { coords, error, getCurrent }
}
